import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { RotateCcw, Trash2 } from 'lucide-react';
import api from '../lib/api';
import { formatDate } from '../lib/format';

export default function Trash() {
  const [items, setItems] = useState([]);
  const load = () => api.get('/trash').then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const restore = async (it) => { await api.post(`/trash/${it.collection}/${it.id}/restore`); toast.success('Restored'); load(); };
  const purge = async (it) => { if (!window.confirm(`Permanently delete "${it.label}"? Type it back if wrong.`)) return; await api.delete(`/trash/${it.collection}/${it.id}/purge`); toast.success('Purged'); load(); };
  return (
    <div className="px-5 py-5 lg:px-10 lg:py-8 max-w-4xl mx-auto">
      <div className="eyebrow">Recovery</div>
      <h1 className="serif text-[28px] mb-5">Trash</h1>
      <div className="text-xs text-[var(--muted)] mb-4">Items deleted in the last 90 days. Nothing is hard-deleted automatically.</div>
      <div className="space-y-2">
        {items.length === 0 && <div className="card-cream p-8 text-center text-sm text-[var(--muted)] italic">Trash is empty.</div>}
        {items.map(it => (
          <div key={it.collection+it.id} className="card-cream p-4 flex justify-between items-center flex-wrap gap-2">
            <div>
              <div className="serif text-[17px]">{it.label}</div>
              <div className="text-xs text-[var(--muted)] mt-1"><span className="uppercase tracking-[0.14em]">{it.collection.replace('_',' ')}</span> · deleted {formatDate(it.deleted_at)}</div>
            </div>
            <div className="flex gap-2">
              <button className="btn-ghost text-xs" onClick={() => restore(it)} data-testid={`trash-restore-${it.id}`}><RotateCcw size={12}/> Restore</button>
              <button className="btn-ghost text-xs" onClick={() => purge(it)} style={{color:'var(--overdue)'}}><Trash2 size={12}/> Purge</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
